import { flow, types, applySnapshot } from "mobx-state-tree";
import api from "services/api";
import { MSURL } from "utils/ms";
const categoryPath = "/workouts/api/v1";

export const CollectionModel = types.model({
  id: types.number,
  name: types.string,
  value: types.string,
  resourceUrlEnglish: types.maybe(types.string),
  buttonEnglish: types.maybe(types.string),
  resourceUrlSpanish: types.maybe(types.string),
  buttonSpanish: types.maybe(types.string),
});

const CollectionStore = types
  .model({
    collections: types.optional(types.array(CollectionModel), []),
    selectedCollection: types.maybe(CollectionModel),
    isCollectionsLoading: types.optional(types.boolean, false),
  })
  .actions(self => ({
    getAllCollections: flow(function*() {
      self.isCollectionsLoading = true;
      try {
        const response = yield api.get(
          `${categoryPath}/collections`,
          undefined,
          undefined,
          MSURL,
        );
        if (response.success) {
          applySnapshot(self.collections, response.data);
        }
        return response;
      } catch (error) {
        console.error("eror:>> ", error);
        throw error;
      } finally {
        self.isCollectionsLoading = false;
      }
    }),
    getCollection: flow(function*(id: number) {
      self.isCollectionsLoading = true;
      try {
        const response = yield api.get(
          `${categoryPath}/collections/${id}`,
          undefined,
          undefined,
          MSURL,
        );
        if (response.success) {
          let data: any = {
            id: response.data.id,
            name: response.data.name,
            value: response.data.value,
            resourceUrlEnglish: undefined,
            buttonEnglish: undefined,
            resourceUrlSpanish: undefined,
            buttonSpanish: undefined,
          };

          response.data.resources &&
            response.data.resources.forEach((element: any) => {
              if (element.localeId && element.localeId === "en-US") {
                data = {
                  ...data,
                  resourceUrlEnglish: element.url,
                  buttonEnglish: element.name,
                };
              } else {
                if (element.localeId && element.localeId === "es-ES") {
                  data = {
                    ...data,
                    resourceUrlSpanish: element.url,
                    buttonSpanish: element.name,
                  };
                }
              }
            });

          applySnapshot(self, {
            ...self,
            selectedCollection: data,
          });
        }
      } catch (error) {
        console.error("eror:>> ", error);
        throw error;
      } finally {
        self.isCollectionsLoading = false;
      }
    }),
    createCollection: flow(function*(data: any) {
      self.isCollectionsLoading = true;
      try {
        const response = yield api.post(
          `${categoryPath}/collections/`,
          data,
          undefined,
          MSURL,
        );
        if (!response.success) {
          console.error(
            "CollectionStore/CreateCollection --- Something wrong with the data: ",
            response.message,
          );
          throw response.message;
        }
        return response.data;
      } catch (error) {
        console.error("error in API consumption with this error: ", error);
        throw error;
      } finally {
        self.isCollectionsLoading = false;
      }
    }),

    updateCollection: flow(function*(data, id, onSuccess) {
      self.isCollectionsLoading = true;
      try {
        const response = yield api.put(
          `${categoryPath}/collections/${id}`,
          data,
          undefined,
          MSURL,
        );
        if (!response.success) {
          console.error(
            "CollectionStore/CreateCollection --- Something wrong with the data: ",
            response.message,
          );
          throw response.message;
        }
        if (onSuccess) onSuccess(response.data);
        return response.data;
      } catch (error) {
        console.error("error in API consumption with this error: ", error);
        throw error;
      } finally {
        self.isCollectionsLoading = false;
      }
    }),
  }));

export default CollectionStore.create();
